import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { NavbarSidebarComponent } from './navbar-sidebar.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxAccordionModule, DxHtmlEditorModule, DxTagBoxModule, DxTextAreaModule, DxPopupModule,DxCheckBoxModule, DxDropDownBoxModule, DxToolbarModule, DxButtonModule, DxActionSheetModule,DxListModule, DxPopoverModule, DxTemplateModule, DxAutocompleteModule, DxTextBoxModule, DxTooltipModule, DxScrollViewModule, DxSelectBoxModule, DxDataGridModule, DxMenuModule, DxGalleryModule, DxTileViewModule, DxResponsiveBoxModule, DxBoxModule} from "devextreme-angular";

@NgModule({
  declarations: [
    NavbarSidebarComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxCheckBoxModule,
    DxDropDownBoxModule,
    DxToolbarModule,
    DxButtonModule,
    DxActionSheetModule,
    DxListModule,
    DxPopoverModule,
    DxTemplateModule,
    DxAutocompleteModule,
    DxTextBoxModule,
    DxPopupModule,
    DxTooltipModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxHtmlEditorModule,
    DxAccordionModule,

    DxMenuModule,
    DxGalleryModule,
    DxTileViewModule,
    DxResponsiveBoxModule,
    DxBoxModule,
    DxTileViewModule,

  ],
  exports: [NavbarSidebarComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class NavbarSidebarModule { }
